<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="this.$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!this.$route.meta.keepAlive" />
  </div>
</template>

<script>
import {  getFingerprint } from './utils/browser'
import { register } from './utils/bigDataSdk'

export default {
  name: "App",
  mounted() {
    getFingerprint().then((cookieId) => {
      const { unionId: unionId, openId: openId } = this.$route.query || {};
      register({ unionId, openId, cookieId });
    });
  },
  methods: {},
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
html,
body {
  height: 100%;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  overflow-x: hidden;
  height: 100%;
}
</style>
